export enum GlobalAsyncRules {
    accessToExternalLinkButton = 'global.access-to-external-link-button',
}

export enum GlobalSyncRules {
    accessToEducationalSheetsAsCards = 'global.access-to-educational-sheets-as-cards',
}